export default __webpack_public_path__ + "static/realWorldImg1-82f16ce6a2cb39de4263d32b0e20cffb.png";